import "./index.css"
import {
  Accordion,
  AccordionList,
  Footer,
  ActionLinks,
  Amount,
  AppContainer,
  BackLink,
  SideNav,
  Hamburger,
  Switch,
  Tooltip,
  Banner,
  BodyContainer,
  BreadCrumb,
  BreakLine,
  Button,
  Card,
  CardBasedOptions,
  CardCaption,
  CardHeader,
  CardLabel,
  CardLabelError,
  CardText,
  CheckBox,
  CitizenHomeCard,
  CitizenInfoLabel,
  CollapseAndExpandGroups,
  ConnectingCheckPoints,
  DatePicker,
  DisplayPhotos,
  Dropdown,
  ErrorMessage,
  HomeFooter,
  HeaderComponent,
  HeaderBar,
  HorizontalNav,
  Tab,
  AlertCard,
  PageBasedInput,
  InputTextAmount,
  KeyNote,
  LabelFieldPair,
  MobileNumber,
  MultiSelectDropdown,
  NoResultsFound,
  OTPInput,
  SidePanel,
  Paragraph,
  PlusMinusInput,
  PopUp,
  PrivateRoute,
  RadioButtons,
  Rating,
  Chip,
  SVG,
  // Table,
  Telephone,
  TextArea,
  TextInput,
  Toast,
  UploadFile,
  WhatsNewCard,
  Toggle,
  ToggleSwitch,
  TreeSelect,
  SubmitBar,
  ButtonSelector,
  InboxSearchLinks,
  SearchComponent,
  LinkLabel,
  RoundedLabel,
  Stepper,
  Timeline,
  StringManipulator,
  InfoButton,
  FileUpload,
  UploadWidget,
  UploadImage,
  ErrorBoundary,
  TextBlock,
  Panels,
  Animation,
  SummaryCardFieldPair,
  Divider,
  ButtonGroup,
  Header,
  HamburgerButton,
  Menu,
  SelectionTag,
  Tag,
  CustomSVG,
  TableMain,
  TableHeader,
  TableFooter,
  TableBody,
  TableRow,
  TableCell,
  NestedTable,
  Loader,
  Iframe,
  AppHelpDrawer,
  HelpInfoCard
} from "./atoms";

import { lazyWithFallback } from "./utils/lazyWithFallback";

import {
  FieldComposer,
  FormComposerCitizen, 
  FieldController,
  Fields,
  FormComposerV2,
  FormComposerStudio,
  Modal,
  UploadFileComposer,
  FieldV1,
  InboxSearchComposer,
  ResultsTable,
  ResultsDataTableWrapper,
  BoundaryFilter,
  ButtonIdentificationProvider,
  SectionIdentificationProvider,
  useButtonIdentification,
  useButtonId,
  generateButtonId,
  AppLocalisationWrapper,
  useCustomT,
  setConstantsforAppConfig,
} from "./hoc";

//exporting all the svg items separately as at few places they are being imported directly
export const {
    FlowFilled,
    VariableAdd,
    FlowUnfilled,
    FontDownload,
    TextAd,
    RadioButtonChecked,
    Numeric123,
    EventList,
    CheckboxSVG,
    VariableAddFilled,
    PlaceholderSvg,
    ProfileIcon,
    AnnouncementIcon,
    ReceiptIcon,
    CreateEstimateIcon,
    GotoInboxIcon,
    ArrowLeft,
    ArrowDown,
    DuplicateIcon,
    CameraSvg,
    DeleteBtn,
    DownloadIcon,
    Ellipsis,
    SuccessSvg,
    ErrorSvg,
    StarFilled,
    StarEmpty,
    SearchIconSvg,
    CheckSvg,
    RoundedCheck,
    Calender,
    Phone,
    FilterSvg,
    SortSvg,
    Close,
    Feedback,
    GetApp,
    HamburgerIcon,
    ArrowBack,
    ArrowForward,
    ArrowRightInbox,
    SortDown,
    SortUp,
    ShippingTruck,
    CloseSvg,
    CalendarIcon,
    UpwardArrow,
    DownwardArrow,
    Poll,
    FilterIcon,
    RefreshIcon,
    RefreshSVG,
    Details,
    PrintIcon,
    PropertyHouse,
    PrimaryDownlaodIcon,
    InfoBannerIcon,
    ShareIcon,
    RupeeIcon,
    ComplaintIcon,
    DropIcon,
    Person,
    WhatsappIcon,
    EmailIcon,
    SmsIcon,
    PushNotifIcon,
    StartStateIcon,
    IntermediateStateIcon,
    EndStateIcon,
    ClearWorkflowIcon,
    ZoomToFitIcon,
    LoadSampleIcon,
    DocumentIcon,
    DocumentIconSolid,
    EventsIconSolid,
    SurveyIconSolid,
    PMBIconSolid,
    DustbinIcon,
    ExternalLinkIcon,
    DownloadImgIcon,
    ViewsIcon,
    PrevIcon,
    DocumentSVG,
    ArrowToFirst,
    ArrowToLast,
    DownloadPrefixIcon,
    CaseIcon,
    PersonIcon,
    PTIcon,
    OBPSIcon,
    OBPSIconSolidBg,
    CitizenTruck,
    FSMIcon,
    EDCRIcon,
    BPAIcon,
    BPAHomeIcon,
    HelpIcon,
    NotificationBell,
    MapMarker,
    Clock,
    EventCalendar,
    ImageIcon,
    TickMark,
    PDFSvg,
    EditIcon,
    SearchIcon,
    DeleteIcon,
    CreateLoiIcon,
    PMBIcon,
    GenericFileIcon,
    ArrowLeftWhite,
    WSICon,
    ArrowVectorDown,
    ArrowDirection,
    CameraIcon,
    RemoveIcon,
    GalleryIcon,
    EditPencilIcon,
    AddressBookIcon,
    LocationIcon,
    CollectionsBookmarIcons,
    FinanceChartIcon,
    CollectionIcon,
    MCollectIcon,
    PGRIcon,
    TLIcon,
    BillsIcon,
    ErrorIcon,
    DownloadBtnCommon,
    PrintBtnCommon,
    WhatsappIconGreen,
    HelpLineIcon,
    ServiceCenterIcon,
    TimerIcon,
    RupeeSymbol,
    ValidityTimeIcon,
    AddIcon,
    SubtractIcon,
    AddNewIcon,
    ViewReportIcon,
    InboxIcon,
    PrivacyMaskIcon,
    FirenocIcon,
    BirthIcon,
    DeathIcon,
    ArrowCollapseUp,
    ArrowCollapseDown,
    AddFilled,
    AddFileFilled,
    LocateIcon,
    NoResultsFoundIcon,
    WorksMgmtIcon,
    BioMetricIcon,
    MuktaHomeIcon,
    HRIcon,
    ProjectIcon,
    EstimateIcon,
    ContractIcon,
    AttendanceIcon,
    WageseekerIcon,
    OrganisationIcon,
    HelperIcon,
    DashboardIcon,
    ExpenditureIcon,
    DoubleTickIcon,
    InfoIcon,
    PaymentIcon,
    HistoryIcon,
    WarningIcon,
    AttentionListIcon,
    UploadIcon,
    FileIcon,
    DeleteIconv2,
    InfoIconOutline,
    XlsxFile,
    JpgFile,
    PdfFile,
    DocFile,
    PngFile,
    DocUpload,
    DocXlsxUpload,
    DocPdfUpload,
    DocdocUpload,
    AddIconNew,
} = CustomSVG;

import {
  ApiDropdown,
  CustomDropdown,
  BottomSheet,
  DetailsCard,
  FormStep,
  InputCard,
  LocationDropdownWrapper,
  MultiUploadWrapper,
  SearchAction,
  SortAction,
  SearchForm,
  SearchField,
  SearchOnRadioButtons,
  TextInputCard,
  PanelCard,
  TooltipWrapper,
  TimelineMolecule,
  LandingPageCard,
  MenuCard,
  LandingPageWrapper,
  MenuCardWrapper,
  TableMolecule,
  MetricCard,
  FormCard,
  FilterCard,
  SummaryCard,
  ResultsDataTable
} from "./molecules";


// import { initCoreLibraries } from "@egovernments/digit-ui-libraries-core";
import { initLibraries } from "@egovernments/digit-ui-libraries";

initLibraries().then(() => {
  console.info("DIGIT Contants enabled");
});

export {
  Footer,
  ActionLinks,
  Amount,
  AppContainer,
  BackLink,
  SideNav,
  Hamburger,
  Accordion,
  Iframe,
  AccordionList,
  Switch,
  Tooltip,
  Banner,
  BodyContainer,
  BreadCrumb,
  BreakLine,
  Button,
  SelectionTag,
  Tag,
  Card,
  CardBasedOptions,
  CardCaption,
  CardHeader,
  CardLabel,
  CardLabelError,
  CardText,
  CheckBox,
  PageBasedInput,
  CitizenHomeCard,
  CitizenInfoLabel,
  CollapseAndExpandGroups,
  ConnectingCheckPoints,
  DatePicker,
  DisplayPhotos,
  Dropdown,
  ErrorMessage,
  HomeFooter,
  HeaderComponent,
  HeaderBar,
  HorizontalNav,
  Loader,
  Tab,
  AlertCard,
  InputTextAmount,
  SearchField,
  KeyNote,
  LabelFieldPair,
  MobileNumber,
  MultiSelectDropdown,
  NoResultsFound,
  OTPInput,
  SidePanel,
  Paragraph,
  PlusMinusInput,
  PopUp,
  PrivateRoute,
  RadioButtons,
  Rating,
  Chip,
  SVG,
  // Table,
  Telephone,
  TextArea,
  TextInput,
  Toast,
  UploadFile,
  WhatsNewCard,
  FieldComposer,
  FieldV1,
  FieldController,
  Fields,
  FormComposerV2,
  FormComposerStudio,
  FormComposerCitizen,
  BoundaryFilter,
  Modal,
  UploadFileComposer,
  ApiDropdown,
  CustomDropdown,
  BottomSheet,
  DetailsCard,
  FormStep,
  InputCard,
  LocationDropdownWrapper,
  MultiUploadWrapper,
  SearchAction,
  SortAction,
  ResultsDataTable,
  SearchForm,
  LandingPageCard,
  MetricCard,
  FormCard,
  FilterCard,
  SummaryCard,
  TableMolecule,
  MenuCard,
  MenuCardWrapper,
  LandingPageWrapper,
  SearchOnRadioButtons,
  TextInputCard,
  PanelCard,
  TimelineMolecule,
  TooltipWrapper,
  Toggle,
  ToggleSwitch,
  TreeSelect,
  SubmitBar,
  ButtonSelector,
  Header,
  HamburgerButton,
  Menu,
  Stepper,
  Timeline,
  StringManipulator,
  InfoButton,
  FileUpload,
  UploadWidget,
  UploadImage,
  TextBlock,
  Panels,
  SummaryCardFieldPair,
  ButtonGroup,
  Divider,
  Animation,
  InboxSearchLinks,
  SearchComponent,
  InboxSearchComposer,
  ResultsTable,
  ResultsDataTableWrapper,
  LinkLabel,
  RoundedLabel,
  // Button Identification System
  ButtonIdentificationProvider,
  SectionIdentificationProvider,
  useButtonIdentification,
  useButtonId,
  generateButtonId,
  //Icons
  CustomSVG,
  ErrorBoundary,
  TableMain,
  TableHeader,
  TableFooter,
  TableBody,
  TableRow,
  TableCell,
  NestedTable,
  AppHelpDrawer,
  HelpInfoCard,
  AppLocalisationWrapper,
  useCustomT,
  setConstantsforAppConfig,
  lazyWithFallback
};
